import React from "react";
import { Navbar, NavbarBrand } from "reactstrap";

export const NavBar = () => (
  <Navbar
    color="info"
    dark
    expand="md"
  >
    <NavbarBrand href="/">
      Simple IOT Test
    </NavbarBrand>
  </Navbar>
);
